import React, { useContext, useEffect, useRef, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import "../../css/main.css";
import useMediaQuery from "../../hooks/useMediaQuery";
import ErrorModal from "../../modals/ErrorModal";
import ProfessionalEMailSentModal from "../../modals/ProfessionalEMailSentModal";
import { ConstantContext } from "../../shared/context/ConstantContext";
import { UserContext } from "../../shared/context/UserContext";
import { isValidEmail } from "../../shared/validations/Email";
import { isValidPincode } from "../../shared/validations/Pincode";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { ProfessionalDetailsWrapper } from "./_styles/ProfessionalDetailsWrapper";
// const getInternalStage = (stage, stage_status) => {
//   if (stage === 'EMAIL' && stage_status === 'INIT') {
//     return 'EMAIL_INIT';
//   } else if (stage === 'EMAIL' && stage_status === 'INCOMPLETE') {
//     return 'EMAIL_INCOMPLETE';
//   } else if (stage === 'EMAIL' && stage_status === 'COMPLETE') {
//     return 'EMAIL_COMPLETE';
//   } else if (stage === 'PROFESSIONAL_DETAILS' && stage_status === 'COMPLETE') {
//     return 'PROFESSIONAL_DETAILS_COMPLETE';
//   } else if (stage === 'CE' && stage_status === 'INIT') {
//     return 'CE_INIT';
//   } else if (stage === 'CE' && stage_status === 'INCOMPLETE') {
//     return 'CE_INCOMPLETE';
//   } else {
//     return 'PROFESSIONAL_DETAILS_INIT';
//   }
// };
import {
  GetCustomerDetailsContext,
  validateInputExistenece
} from "../../App";
import {
  BEUREU_POLLING,
  DS_PARSER,
  EPL_SOURCE,
  ESB_DSA_SOURCE,
  GET_CONSTANTS,
  GET_ORG_NAME,
  INCOME_CHECK,
  INSERT_PROFESSIONAL_DETAILS,
  KARZA_CHECK,
  PINCODE_MASTER,
  SEND_EMAIL_OTP,
  VERIFY_EMAIL_OTP,
  call_UPSELL_CE,
  GST_SEARCH,
  GST_VERIFY_DETAILS,
  GST_GET_DETAILS,
  GST_RETURN_DETAILS,
  INSERT_SELF_EMPLOYED_DETAILS,
} from "../../Config";
import icon_modal from "../../assets/svg/EPL_think_svg/Icon_modal.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import FloatingInput from "../../components/base/FloatingInput";
import { updateLead } from "../../shared/services/crm";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidName } from "../../shared/validations/Name";
import { isValidNumber } from "../../shared/validations/Numeric";
import { isValidOTP } from "../../shared/validations/OTP";
import isEmpty from "../../shared/validations/common/isEmpty";
import {
  DSAsyncRetryModal,
  DsEligibilityFailed,
  IncomeFailed,
  IncorrectOtpModal,
  IncorrectPinCodeModal,
  KarzaFailed,
  MaxOtpRetryModal,
  OtpExpiredModal,
  ResendOtpEmailModal,
  SelfEmpWarnModal,
} from "../other-pages/Modals/AllModal";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import isEnglish, { isEnglishNewCheck } from "../../shared/validations/isEnglish.js";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal.js";
import { encryptedData } from "../../utils/index.js";

const ProfessionalDetails = (props) => {
  moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const [customerDetails, setCustomerDetails] = useState(props.customerDetails);
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(true);

  useEffect(async () => {
    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    // window.scrollTo(0, 0);
    // getConstants();
    // await GetCustomerDetails(
    //   customerDetails.application_form_number,
    //   customerDetails.source,
    //   customerDetails,
    //   setCustomerDetails
    // );
    if (customerDetails.source === "upsell") {
      // setPAN(customerDetails);
    }
    setDataCaptured(true);
    if (customerDetails?.Data?.isTruncated == true || customerDetails?.Data?.isTruncated === "True"){
			setEmploymentType("self_employed");
      			
			setIncome(customerDetails?.Data?.monthly_income)
			setIncomeDisabled(true)

			setCompanyName(customerDetails?.Data?.org_name)
			setCompanyNameDisabled(true)

			setCompanyAddress(customerDetails?.Data?.org_address)
			setCompanyAddressDisabled(true)

			setOfficePincode(customerDetails?.Data?.office_pin_code)
			setOfficePincodeDisabled(true)
			await pinCodeMaster(customerDetails?.Data?.office_pin_code)

			await fetchGSTNumbers()
		}
    // console.log("TESTING ->", customerDetails);
  }, []);


  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("ProfessionalDetails customerDetails: ", customerDetails);
      if (customerDetails?.Data?.isTruncated !== true && customerDetails?.Data?.isTruncated !== "True") {
				setShowShimmer(false);
			}
      // TODO: Mostly No need of stage here...

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      if (customerDetails?.Data?.isError === "True") {
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          if (customerDetails?.Data?.api_name === "employmentCheck"  && employmentType === "salaried") {
            // await karzaAPI();
          }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
      else{
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
    }
    } else {
      // console.log("ProfessionalDetails Ouch customerDetails ");
    }
  }, [customerDetails]);

  const { setConstant } = useContext(ConstantContext);
  const [employmentType, setEmploymentType] = useState("salaried");
  const updateEmploymentType = (e) => {
    if (e.target.value === "self_employed") {
      fetchGSTNumbers()
    }

    setEmploymentType(e.target.value);
    setCompanyName("");
    setGstNumber("");
    setCompanyNameDisabled(false)
    // console.log("selected", e.target.value);
    if (e.target.value === "self_employed" && customerDetails?.source !== ESB_DSA_SOURCE) {
      // console.log("heeeerrereer");
      setSelfEmpWarn(true);
    }
  };
  const [selfEmpWarn, setSelfEmpWarn] = useState(false);
  const [consentCheckbox, setConsentCheckbox] = useState(true);
  const [dropDownLabels, setDropDownLabels] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [dataCaptured, setDataCaptured] = useState();
  const [isDSEligibilityFailed, setIsDSEligibilityFailed] = useState(false);
  const [dsAsyncRetryModal, setDsAsyncRetryModal] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const [gstNumberError, setGstNumberError] = useState(false);
  const [gstNumberDisabled, setGstNumberDisabled] = useState(false);
  const [gstNumberOptions, setGstNumberOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const isFirstSelectionRef = useRef(true);
  const previousGstNumberRef = useRef("");

  const fetchGSTNumbers = async () => {
    setShowShimmer(true);
    try {
      const payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_SEARCH,
        formData
      );
      if (response.response.Success) {
        response.response.Data.push("None Of The Above")
        setGstNumberOptions(createGSTDropDownOptions(response.response?.Data));
      } else {
				if (customerDetails?.Data?.isTruncated == true || customerDetails?.Data?.isTruncated === "True"){
					setCustomerDetails({
						...customerDetails,
						stage: response.response.STAGE,
					});
				} else {
					setGstNumberOptions(null);
				}
			}
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const createGSTDropDownOptions = (gstNumbers, isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < gstNumbers.length; i++) {
      if (
        isFilter &&
        gstNumbers[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: gstNumbers[i],
          value: gstNumbers[i],
          func: () => {
            setGstNumber(gstNumbers[i]);
            handleGstSelection(gstNumbers[i]);
            showDropdownGST("GSTNumber");
          },
        });
      } else if (!isFilter) {
        options.push({
          label: gstNumbers[i],
          value: gstNumbers[i],
          func: () => {
            setGstNumber(gstNumbers[i]);
            handleGstSelection(gstNumbers[i]);
            showDropdownGST("GSTNumber");
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setGstNumber("");
          showDropdownGST("GSTNumber");
        },
      });
    }
    return options;
  };

  const handleGstSelection = (gst) => {
    if (gst === "None Of The Above") {
      if (customerDetails?.Data?.isTruncated == true || customerDetails?.Data?.isTruncated === "True") {
				setCompanyName(customerDetails?.Data?.org_name)
				setCompanyNameDisabled(true)
				previousGstNumberRef.current = gst;
				return;
			} else {
				setCompanyName("");
				setCompanyNameDisabled(false)
				previousGstNumberRef.current = gst;
				return;
			}
    }
    if (isFirstSelectionRef.current) {
      fetchGstDetails(gst);
      previousGstNumberRef.current = gst;
      isFirstSelectionRef.current = false;
    } else {
      if (previousGstNumberRef.current === "None Of The Above") {
        fetchGstDetails(gst);
        previousGstNumberRef.current = gst;
      } else if (gst !== previousGstNumberRef.current) {
        setShowModal(true);
      }
    }
  };  

  const fetchGstDetails = async (selectedGstNumber) => {
    setShowShimmer(true);
    try {
      const payload = {
        gst_number: selectedGstNumber,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_GET_DETAILS,
        formData
      );
      if (response.response.Success) {
        if (response?.response?.Data?.name_of_business) {
          setCompanyName(response?.response?.Data?.name_of_business)
          setCompanyNameDisabled(true)
        }
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const gstReturnDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
        gst_number: gstNumber
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_RETURN_DETAILS,
        formData
      );
      if (response.response.Success) {
        await gstVerifyDetails()
      } else {
        await insertSelfEmployedDetails()
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const gstVerifyDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_VERIFY_DETAILS,
        formData
      );
      if (response.response.Success) {
        await insertSelfEmployedDetails()
      } else {
        await insertSelfEmployedDetails()
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const insertSelfEmployedDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
        business_address: companyAddress,
        city: city,
        state: state,
        pin_code: officePincode,
        business_name: companyName,
        employment_type: employmentType,
        business_income: income
      };
      if (gstNumber) {
        payload.gst_number = gstNumber;
      }
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + INSERT_SELF_EMPLOYED_DETAILS,
        formData
      );
      if (response.response.Success) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const handleConfirmChange = async () => {
    await fetchGstDetails(gstNumber); // Fetch details for the new GST number
    previousGstNumberRef.current = gstNumber; // Update previous GST number
    setShowModal(false); // Close the modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
    setGstNumber(previousGstNumberRef.current); // Reset to previous GST number
  };

  const showDropdownGST = () => {
    document.getElementById("myDropdownGST").classList.toggle("show");
  };

  // const getConstants = async () => {
  //   // console.log("Inside getConstants");
  //   try {
  //     // setShowShimmer(true);
  //     const response = await sendRequest(
  //       "/" + customerDetails.source + GET_CONSTANTS,
  //       {}
  //     );
  //     // console.log("getConstants: response => ", response);
  //     // setShowShimmer(false);
  //     if (response.response.Success) {
  //       setConstant(response.response.Data);
  //       // console.log(
  //       //   "response.response.Data.COMPANY_NAMES.value",
  //       //   response.response.Data.COMPANY_NAMES.value
  //       // );
  //       setDropDownLabels(response.response.Data.COMPANY_NAMES.value);
  //       setDropDownOptions(
  //         createDropDownOptions({
  //           dropDownLabel: response.response.Data.COMPANY_NAMES.value,
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     if (customerDetails.source === "upsell") {
  //       updateLead(customerDetails.source, 64, customerDetails.application_form_number)
  //     }
  //     // setShowShimmer(false);
  //     console.error(
  //       `getConstants: Unknown Error: Constants Not Retireved - ${error}`
  //     );
  //     var route = getRouteFromLoanStageService({
  //       source: customerDetails.source,
  //       stage: "error",
  //     });
  //     // // console.log("stage: ", customerDetails.stage);
  //     // console.log("route: ", route);
  //     navigate(`${route}`, {
  //       replace: true,
  //     });
  //   }
  // };

  const getOrgName = async (orgName) => {
    if(employmentType === "self_employed"){
			return;
		}
    try {
      const formData = new FormData();
      const payload = {
        company: orgName,
      };
      formData.append("data", encryptedData(payload));
      try {
        const response = await sendRequest(
          "/" + customerDetails.source + GET_ORG_NAME,
          formData
        );
        if (response.response.Success) {
          if (response.response.data.length === 0) {
            setDropDownLabels(["No Company Found"])
            setDropDownOptions(
              createDropDownOptions({
                dropDownLabel: ["No Company Found"],
              })
            );
          }
          else {
            setDropDownLabels(response.response.data);
            setDropDownOptions(
              createDropDownOptions({
                dropDownLabel: response.response.data,
              })
            );
          }

        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            64,
            customerDetails.application_form_number
          );
        }
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          console.error(`Unknown Error: ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };


  const pinCodeMaster = async (officePincode) => {
    try {
      const payload = {
        pincode: officePincode,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + PINCODE_MASTER,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        if (response.response.Success === true) {
          if (response.response.Data.pl_serviceable == 0) {
            setOfficePincodeError(true);
            setPincodeErrorMessage("Incorrect Pincode");
            setPincodeVerified(false);
            setCity("");
            setState("");
          } else {
            setCity(response.response.Data.city);
            setState(response.response.Data.state);
          }
        } else {
          setOfficePincodeMasterError(true);
          setOfficePincodeError(true);
          setPincodeVerified(false);
          setPincodeServiceableButtonDisabled(true);
          setPincodeInfoMessage("Required so we can service you better");
          setPincodeErrorMessage("Incorrect Pincode");
          setCity("");
          setState("");
        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          updateLead(customerDetails.source, 64, customerDetails.application_form_number)
        }
        console.error(`Unknown Error: ${error}`);
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
      } finally {
        setShowShimmer(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      // console.log(error);
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(async () => {
    // window.scrollTo(0, 0);
    // console.log("INSIDE USEFFECT OF PROF", customerDetails.Data.org_name);
    if (customerDetails.source === "upsell") {
      setCompanyName(customerDetails.Data.org_name);
      setCompanyAddress(customerDetails.Data.org_address);
      setOfficePincode(customerDetails.Data.office_pin_code);
      setCompanyEmailError(
        !isValidEmail(
          customerDetails.Data.org_email_id !== "None"
            ? customerDetails.Data.org_email_id
            : "" || ""
        )
      );
      await pinCodeMaster(customerDetails.Data.office_pin_code);
    }
  }, [dataCaptured]);
  // // const dropDownLabels = ["Aditya Birla Capital", "Wipro", "Infosys", "Others"];

  const createDropDownOptions = ({
    dropDownLabel = dropDownLabels,
    isFilter = false,
    filterText = "",
  }) => {
    // setShowShimmer(true);
    const options = [];
    // console.log("Creating Loan Purpose Options\n", dropDownLabel);
    // options.push(<option value="DEFAULT:disabled" key="disabled:Purpose of Loan" disabled>Purpose of Loan</option>);
    // for (let i = 0; i < dropDowns.length; i++) {
    //     options.push(<option key={i+":"+dropDowns[i]} value={dropDowns[i]}>{dropDowns[i]}</option>);
    // }
    // options.push({ label: "Purpose of Loan", value: "DEFAULT:disabled"});
    for (let i = 0; i < dropDownLabel.length; i++) {
      if (
        isFilter &&
        dropDownLabel[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: dropDownLabel[i],
          value: dropDownLabel[i],
          func: () => {
            if (dropDownLabel[i] !== "No Company Found"){
              setCompanyName(dropDownLabel[i]);
              setCompanyNameError(false);
            }
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: dropDownLabel[i],
          value: dropDownLabel[i],
          func: () => {
            if (dropDownLabel[i] !== "No Company Found"){
              setCompanyName(dropDownLabel[i]);
              setCompanyNameError(false);
            }
            if (dropDownLabel[i] === "No Company Found"){
              setCompanyName("");
              getOrgName("A")
            }
            showDropdown();
          },
        });
      }
    }

    return options;
  };


  const [dropDownOptions, setDropDownOptions] = useState([]);
  // const [dropDown, setDropDown] = useState();
  const [dropDownPlaceholder, setDropDownPlaceholder] =
    useState("Organization Name");
  var defaultDropDownPlaceholderStyle = {
    // width: "100%",
    // fontSize: "20px",
    // color: "red", // "var(--color-bw_americansilver)",
    // outline: "none",
    // backgroundColor: "transparent",// "var(--color-input-bg)",
    // transition: "all 0.1s ease",
    position: "absolute",
    // content: "${(props) => props.label}";
    width: "max-content",
    left: "0.75em",
    top: "50%",
    padding: "0px 0.25em",
    transform: "translateY(-50%)",
    color: "#717171", // var(--color-bw_black);
    border: "none",
    borderRadius: "2px",
    fontSize: "20px",
    pointerEvents: "none",
    transition: "all 0.3s ease",
  };
  const [dropDownPlaceholderStyle, setDropDownPlaceholderStyle] = useState(
    defaultDropDownPlaceholderStyle
  );

  const dropDownChange = (filterText) => {
    const comNameRegex = /^[a-z A-Z0-9.]+$/;
    const isValid =
      comNameRegex.test(filterText) && /[a-zA-Z0-9]/.test(filterText);

    if (!isValid) {
      setCompanyNameError(true);
      setCompanyName("");
    } else {
      setCompanyName(filterText);
      setCompanyNameError(false);
      setDropDownOptions(
        createDropDownOptions({ isFilter: true, filterText: filterText })
      );
    }
  };

  const dropDownFocus = (event) => {
    // console.log("EVENT: ", event);
    // setDropDownPlaceholder("");
    var focusStyle = {
      top: "-0.5em",
      left: "0.25em",
      fontSize: "16px",
    };
    setDropDownPlaceholderStyle(focusStyle);
  };

  const blurDropDown = (event) => {
    setDropDownPlaceholderStyle(defaultDropDownPlaceholderStyle);
  };

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };

  const { constant } = useContext(ConstantContext);
  // console.log("constant: ", constant);
  const totalWorkExperienceOptions = constant.YEARS_OF_EXPERIENCE;
  // console.log("totalWorkExperienceOptions: ", totalWorkExperienceOptions);
  const companyNameOptions = constant.COMPANY_NAMES;
  // console.log("companyNameOptions: ", companyNameOptions);

  const { user, setUser } = useContext(UserContext);
  // const applicationFormNumber = user.application_form_no;
  // const [internalStage, setInternalStage] = useState(
  //   getInternalStage(user.Stage.stage, user.Stage.stage_status)
  // );

  // const [applicationFormNumber, setApplicationFormNumber] = useState("EPL000000009");
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [companyNameDisabled, setCompanyNameDisabled] = useState(false);
  const [companyNameInput, setCompanyNameInput] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyEmailDisabled, setCompanyEmailDisabled] = useState(false);
  const [companyEmailError, setCompanyEmailError] = useState(false);
  const [companyEmailErrorMessage, setCompanyEmailErrorMessage] =
    useState("Incorrect Email!");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyEmailVerified, setCompanyEmailVerified] = useState(false);
  const [karzaFailedError, setKarzaFailedError] = useState(false);
  const [incomeFailedError, setIncomeFailedError] = useState(false);
  const [companyCategoryError, setCompanyCategoryError] = useState(false);
  // const [
  //   companyEmailSendVerificationEmailButtonDisabled,
  //   setCompanyEmailSendVerificationEmailButtonDisabled
  // ] = useState(true);
  const [
    companyEmailSendVerificationButtonVisible,
    setCompanyEmailSendVerificationButtonVisible,
  ] = useState(true);
  // const [netMonthlyIncome, setNetMonthlyIncome] = useState(
  //   isValidNetMonthlyIncome(user.monthly_salary) ? user.monthly_salary : ''
  // );
  const [netMonthlyIncomeDisabled, setNetMonthlyIncomeDisabled] =
    useState(false);
  const [netMonthlyIncomeError, setNetMonthlyIncomeError] = useState(false);
  // const [netMonthlyExpense, setNetMonthlyExpense] = useState(
  //   isValidNetMonthlyExpense(user.net_monthly_expense) ? user.net_monthly_expense : ''
  // );
  const [netMonthlyExpenseDisabled, setNetMonthlyExpenseDisabled] =
    useState(false);
  const [netMonthlyExpenseError, setNetMonthlyExpenseError] = useState(false);
  const [totalWorkExperience, setTotalWorkExperience] = useState();
  // isValidTotalWorkExperience(user.years_in_current_organization)
  //   ? user.years_in_current_organization
  //   : ''
  const [totalWorkExperienceDisabled, setTotalWorkExperienceDisabled] =
    useState(false); // ('');
  const [officePincode, setOfficePincode] = useState();
  const [totalWorkExperienceError, setTotalWorkExperienceError] =
    useState(false);

  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [modal, setModal] = useState(false);
  const [
    officePincodeServiceableButtonDisabled,
    setOfficePincodeServiceableButtonDisabled,
  ] = useState(false);

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [officePincodeError, setOfficePincodeError] = useState(false);
  const [officePincodeMasterError, setOfficePincodeMasterError] =
    useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");
  const [pincodeVerified, setPincodeVerified] = useState(false);
  const [
    pincodeServiceableButtonDisabled,
    setPincodeServiceableButtonDisabled,
  ] = useState(true);
  const [pincodeInfoMessage, setPincodeInfoMessage] = useState(
    "Required so we can service you better"
  );
  const [income, setIncome] = useState("");
  const [incomeError, setIncomeError] = useState(false);
  const [incomeErrorMessage, setIncomeErrorMessage] = useState("");
  const [incomeDisabled, setIncomeDisabled] = useState(false);
  const [companyAddressDisabled, setCompanyAddressDisabled] = useState(false);
  const [officePincodeDisabled, setOfficePincodeDisabled] = useState(false);
  const [companyAddressError, setCompanyAddressError] = useState(false);
  // const updateCompanyName = (e) => {
  //   setCompanyName(e.target.value);
  //   setCompanyNameError(!isValidName(e.target.value));
  // };
  const updateCompanyAddress = (e) => {
    setCompanyAddressError(false);
    setCompanyAddress(e.target.value);
    if (!isEnglishNewCheck(e.target.value)) {
      setCompanyAddressError(true);
    }
  };
  const updateCompanyEmail = (e) => {
    setCompanyEmail(e.target.value);
    setCompanyEmailError(!isValidEmail(e.target.value));
  };

  const inValidNumericEntries = ["e", "-"];

  const updateIncome = (e) => {
    setIncome(e.target.value);
    console.log("e.target.value: ", e.target.value);
    if (inValidNumericEntries.includes(e.target.value)) {
      e.preventDefault();
    }
    else if (parseInt(e.target.value) < 0) {
      e.preventDefault();
      setIncomeError(true);
      setIncomeErrorMessage("Income should be greater than 0");
    }
    else if (isValidNumber(e.target.value)) {
      setCustomerDetails({
        ...customerDetails,
        income: e.target.value,
      });
      setIncomeError(false);
      setIncomeErrorMessage("");
    } else {
      setIncomeError(true);
      setIncomeErrorMessage("Please enter valid income");
    }
  };

  const updateOfficePincode = async (e) => {
    setOfficePincode(e.target.value.slice(0, 6));
    if (String(e.target.value).length < 6) {
      // console.log("");
      setOfficePincodeError(true);
      setPincodeVerified(false);
      setPincodeServiceableButtonDisabled(true);
      setPincodeInfoMessage("Required so we can service you better");
      setPincodeErrorMessage("Incorrect Pincode");
      // Dummy Code
      setCity("");
      setState("");
    } else if (String(e.target.value).length === 6) {
      if (isValidPincode(e.target.value)) {
        setOfficePincodeError(false);
        setPincodeVerified(false);
        setPincodeServiceableButtonDisabled(false);
        // Dummy Code
        await pinCodeMaster(e.target.value);
      }
    }
  };
  useEffect(() => {
    if (companyName !== "") {
      const timeOutId = setTimeout(() => getOrgName(companyName), 1000);
      return () => clearTimeout(timeOutId);
    }
  }, [companyName]);

  const updateTotalWorkExperience = (e) => {
    setTotalWorkExperience(e.label);
    setTotalWorkExperienceError(e.label); //!isValidTotalWorkExperience(e.label));
  };

  const callInsertProfessionalDetailsAPI = async () => {
    moengage.track_event("Professional", {
      journeyName: customerDetails.source,
      "ds verified": isDSEligibilityFailed ? "NO" : "Yes", // boolean value
    });
    try {
      setShowShimmer(true);
      var company_name_df = document.querySelector("#company-name");
      const formData = new FormData();
      const requestData = {
        office_address1: companyAddress,
        city: city,
        state: state,
        pin_code: officePincode,
        company_name: companyName, // "ABFL - Aditya Birla Finance Limited",
        employment_type: employmentType,
        org_email_id: companyEmail,
        monthly_income: income
      };
      console.log("requestData: ", requestData);
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + INSERT_PROFESSIONAL_DETAILS,
        formData
      );
      setShowShimmer(false);

      if (response.response.Success === true) {
        // await karzaCallback(requestData);
        if (["epl"].includes(customerDetails.source)) {
          await beureuPolling(); // CIBIL
        }
        else if ([ESB_DSA_SOURCE].includes(customerDetails.source)) {
          await incomeCheck();
        }
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setCompanyCategoryError(true);
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }

      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
    // }
  };

  const incomeCheck = async () => {
    try {
      setShowShimmer(true);
      const formData = new FormData();
      const requestData = {
      };
      console.log("requestData: ", requestData);
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + INCOME_CHECK,
        formData
      );
      setShowShimmer(false);

      if (response.response.Success === true) {
        // await beureuPolling();
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setIncomeFailedError(true);
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
    // }
  };

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const beureuPolling = async () => {
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + BEUREU_POLLING,
        formData1
      );
      // console.log("employmentCheck: ", response);
      setShowShimmer(false);
      if (response.response.Success === true) {
        await dsParserCall();
      } else {
        // Unsuccessful ResponseStatus Handling
        // console.log("Unsuccess in KarzaAPI");
      }
    } catch (error) {
      // setShowShimmer(false);
      // console.log("Unknown Error: ", error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // return false;
    }
  };
  const dsParserCall = async () => {
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
      };
      if ([ESB_DSA_SOURCE].includes(customerDetails.source)) {
        employmentCheckPayLoad["current_stage"] = customerDetails.stage;
      }
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + DS_PARSER,
        formData1
      );
      if (response.response.Success) {
        if (customerDetails.source === "epl") {
          await karzaAPI();
        } else {
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
          updateLead(customerDetails.source, 97, customerDetails.application_form_number)
        }
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setIsDSEligibilityFailed(true);
          updateLead(customerDetails.source, 105, customerDetails.application_form_number)
        }
      }
      setShowShimmer(false);
    } catch (error) {
      setDsAsyncRetryModal(true);
    }
  };

  const karzaAPI = async () => {
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
        current_stage: customerDetails.stage,
        stage_conditions: {
          professionalDetailsChange: false,
        },
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + KARZA_CHECK,
        formData1
      );
      // console.log("employmentCheck: ", response);
      setShowShimmer(false);
      if (response.response.Success === true) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        if (response.response.otpVerifyRequired) {
          setSeconds(10);
          setMinutes(0);
          // console.log("heereereererer>>>>>>");
          setShowOtpModal(true);
        } else {
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
          if (customerDetails.source === "upsell") {
            callCE();
            updateLead(
              customerDetails.source,
              51,
              customerDetails.application_form_number
            );
          }
        }
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setKarzaFailedError(true);
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              81,
              customerDetails.application_form_number
            );
          }
          const updated = customerDetails;
          updated.stage = response.response.STAGE;
          setCustomerDetails({
            ...updated,
          });
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      // setShowShimmer(false);
      // console.log("Unknown Error: ", error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // return false;
    }
  };

  const resendOTP = async () => {
    var payload = {
      email: companyEmail,
      mode: "EMPLOYMENT_CHECK",
      email: companyEmail,
      mode: "EMPLOYMENT_CHECK",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + SEND_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowOtpModal(false);
        // console.log("Otp sent");
        setShowShimmer(false);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(0);
        setSeconds(10);
        resetOTP();
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setMinutes(15);
        setSeconds(1);
        SetEnableResendOtp(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const VerifyOTPOnEmail = async () => {
    try {
      var payload = {
        otp: otp,
        email: companyEmail,
        mode: "EMPLOYMENT_CHECK",
        current_stage: customerDetails.stage,
        stage_conditions: {
          professionalDetailsChange: false,
        },
      };
      setShowOtpModal(false);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + VERIFY_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowShimmer(false);
        // console.log("Otp Verified");
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        if (customerDetails.source === "upsell") {
          callCE();
        }
      }
      if (response.response.ErrorType == "INVALID_OTP") {
        setShowShimmer(false);
        // console.log("incorrect");
        SetIsOtpWrong(true);
      }
      if (response.response.ErrorType == "OTP_EXPIRED") {
        setShowShimmer(false);
        setShowOtpExpiredModal(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const callCE = async () => {
    try {
      var payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + call_UPSELL_CE,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        //pass
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 64, customerDetails.application_form_number)
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const allFieldsValidated = () => {
    let validEmail = isValidEmail(companyEmail);
    if (employmentType !== "salaried" && customerDetails?.Data?.isTruncated == true || customerDetails?.Data?.isTruncated === "True") {
      return (
        isValidName(companyName) &&
        income &&
        isValidPincode(officePincode) &&
        city != "" &&
        state != "" &&
        !isEmpty(companyAddress.trim()) &&
        !companyAddressError &&
        (
          !gstNumberOptions ||
          (gstNumber.length != 0 && !gstNumberError)
        )
      )
    }
    if (employmentType !== "salaried") {
      validEmail = true;
      return (
        consentCheckbox &&
        isValidName(companyName) &&
        isValidNumber(income) &&
        validEmail &&
        isValidPincode(officePincode) &&
        city != "" &&
        state != "" &&
        !isEmpty(companyAddress.trim()) &&
        !companyAddressError &&
        (
          !gstNumberOptions || 
          (gstNumber.length != 0 && !gstNumberError)
        )
      )
    }
    if (customerDetails.source === EPL_SOURCE) {
      return (
        consentCheckbox &&
        isValidName(companyName) &&
        // dropDownLabels.includes(companyName) &&
        isValidPincode(officePincode) &&
        validEmail &&
        !isEmpty(companyAddress.trim()) &&
        city != "" &&
        state != ""
      );
    }
    else if (customerDetails.source === ESB_DSA_SOURCE) {
      return (
        consentCheckbox &&
        isValidName(companyName) &&
        isValidNumber(income) &&
        validEmail &&
        isValidPincode(officePincode) &&
        !isEmpty(companyAddress.trim()) &&
        !companyAddressError &&
        city != "" &&
        state != ""
      );
    }
    else if (customerDetails.source === "upsell") {
      return (
        consentCheckbox &&
        isValidName(companyName) &&
        validEmail &&
        isValidPincode(officePincode) &&
        !isEmpty(companyAddress.trim()) &&
        city != "" &&
        state != ""
      );
    }
  };

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  return (
    <>
      <>
        <ScenarioBasedModal
          id="bd-modal"
          isOpen={showModal}
          showCloseButton={false}
          secondButton={true}
          modalMessageHeading="Change GST Number"
          modalMessage="Do you wish to change the selected GST number?"
          modalSubmitMessagebutton2="Yes"
          onModalSubmitbutton2={handleConfirmChange}
          modalSubmitMessage="No"
          onModalSubmit={handleCloseModal}
        />
        <Modal
          open={showOtpModal}
          showCloseButton={false}
          closeonClickOutside={false}
          onClose={() => {
            // setShowOtpModal(false);
          }}
          id="bd-email-otp-parent"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="modal-body"
                style={{
                  border: "1px solid #A7A7A7",
                  padding: "1rem",
                }}
              >
                <div className="pupup-inner">
                  <div className="title text-center">
                    <h2 className="fs-36 font-weight-medium text-black mb-2 lh-1">
                      Verify Office Email{" "}
                    </h2>
                    <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                      by entering OTP
                    </p>
                  </div>
                  <form>
                    <div
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                    >
                      <div>
                        <OTPInput
                          length={6}
                          otpDigits={otpDigits}
                          setOtpDigits={setOtpDigits}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        color: "#717171",
                        fontSize: "12px",
                        marginTop: "10px",
                        marginBottom: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {enableResendOtp ? (
                          <></>
                        ) : (
                          <>
                            <img
                              style={{
                                height: "15px",
                                width: "15px",
                                justifyContent: "center",
                                marginRight: "4px",
                              }}
                              src={timer}
                            />
                          </>
                        )}
                        <text
                          style={{
                            border: "None",
                            backgroundColor: "white",
                            color: enableResendOtp ? "#3C94FC" : "grey",
                            marginRight: "5px",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            resendOTP();
                          }}
                        >
                          Re-send OTP
                        </text>
                      </div>
                      {enableResendOtp ? (
                        <></>
                      ) : (
                        <>
                          <div>
                            in {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                      <div className="col-wrap text-center">
                        <Button
                          id="VerifyOTP"
                          className="Btn VerifyOTP"
                          disabled={!isOtpValid}
                          mobile={isMobile}
                          onClick={async () => {
                            await VerifyOTPOnEmail();
                          }}
                          text={"Verify"}
                        />
                      </div>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        paddingTop: "15px",
                      }}
                    >
                      6 digit verification code sent to office email ID will be
                      valid for next 5 minutes.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <OtpExpiredModal
          isOpen={showOtpExpiredModal}
          onClose={() => {
            setShowOtpExpiredModal(false);
            setShowOtpModal(true);
            SetEnableResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <ResendOtpEmailModal
          isOpen={resendOtp}
          onClose={() => {
            setShowOtpModal(true);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <SelfEmpWarnModal
          isOpen={selfEmpWarn}
          modalImage={icon_modal}
          onClose={() => {
            setSelfEmpWarn(false);
            setEmploymentType("salaried");
          }}
        />
        <MaxOtpRetryModal
          isOpen={showMaxRetryModal}
          onClose={() => {
            setShowMaxRetryModal(false);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setMinutes(15);
            setSeconds(1);
            resetOTP();
          }}
        />
        <DSAsyncRetryModal
          isOpen={dsAsyncRetryModal}
          onClose={() => {
            setDsAsyncRetryModal(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <IncorrectOtpModal
          isOpen={isOtpwrong}
          onClose={() => {
            SetIsOtpWrong(false);
            setShowOtpModal(true);
            resetOTP();
          }}
        />
        <IncorrectPinCodeModal
          isOpen={officePincodeMasterError}
          onClose={() => {
            setOfficePincodeMasterError(false);
          }}
        />
        <KarzaFailed
          isOpen={karzaFailedError}
          onClose={() => {
            setKarzaFailedError(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <IncomeFailed
          isOpen={incomeFailedError}
          onClose={() => {
            setIncomeFailedError(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <DsEligibilityFailed
          isOpen={isDSEligibilityFailed}
          onClose={() => {
            setIsDSEligibilityFailed(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <Loading open={modal === "LOADING"} />
        <Loading
          open={modal === "LOADING_CE_WAIT"}
          msg="Please wait... this may take sometime"
        />
        <Modal
          open={modal === "EMAIL_SENT"}
          onClose={() => setModal(false)}
          showCloseButton={false}
          closeOnClickOutside={false}
        >
          <ProfessionalEMailSentModal />
        </Modal>
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <Modal
          open={modal === "TECHNICAL_ERROR_CE_MAXRETRY"}
          onClose={() => setModal("")}
        >
          <ErrorModal
            heading="Oops, something went wrong!!"
            subheading="Please close the window and try again in some time."
            onClick={() => {
              setModal("");
            }}
          />
        </Modal>
        <ProfessionalDetailsWrapper className="first-child">
          <ShimmerPlaceholder
            visible={showShimmer}
            height="4em"
            marginTop="2em"
            justifyContent="flex-start"
          />
          <SubTitle
            style={{
              display: "flex",
              fontSize: "18px",
              marginTop: "10px",
              marginLeft: "5px",
            }}
            text="Employment Type"
            visible={!showShimmer && (customerDetails?.Data?.isTruncated === false || customerDetails?.Data?.isTruncated === "False")}
          />
          {
						customerDetails?.Data?.isTruncated == false || customerDetails?.Data?.isTruncated === "False" ? <div
            style={{
              display: showShimmer ? "none" : "flex",
            }}
            className={"additional-confirm"}
          >

            <div style={{ display: "contents" }}>
              <input
                type="radio"
                id="salaried"
                name="salaried"
                checked={employmentType === "salaried"}
                value={"salaried"}
                onChange={updateEmploymentType}
              />
              <label for="salaried">Salaried</label>
            </div>
            <div style={{ display: "contents" }}>
              <input
                type="radio"
                id="self_employed"
                name="self_employed"
                checked={employmentType === "self_employed"}
                value={"self_employed"}
                onChange={updateEmploymentType}
              />
              <label for="self_employed">Self-Employed</label>
            </div>
            <div style={{ width: "10%" }}></div>

          </div>: <></>
					}
          {employmentType === "self_employed" && gstNumberOptions &&
            <div className="professional-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                id="GSTNumber"
                visible={!showShimmer}
                type={"text"}
                value={gstNumber}
                error={gstNumberError}
                error_message="Select GST Number"
                label={"GST Number"}
                disabled={gstNumberDisabled}
                optionsGST={gstNumberOptions}
              />
            </div>
          }
          {customerDetails.source === ESB_DSA_SOURCE && (
            <>
              <ShimmerPlaceholder visible={showShimmer} marginTop="0.5em" />
              <div className="professional-form-input">
                <FloatingInput
                  visible={!showShimmer}
                  label={"Net Monthly Income"}
                  id="income"
                  type="Number"
                  value={income}
                  error={incomeError}
                  error_message={incomeErrorMessage}
                  disabled={incomeDisabled}
                  on_change={updateIncome}
                />
              </div>
            </>
          )}
          <form className="professional-form">
            <ShimmerPlaceholder visible={showShimmer} />
            <div className="professional-form-input">
              <FloatingInput
                visible={!showShimmer}
                on_change={(e) => {
                  dropDownChange(e.target.value);
                }}
                type={"text"}
                value={companyName}
                error={companyNameError}
                disabled={companyNameDisabled}
                error_message="Enter a valid name"
                label={customerDetails.source === ESB_DSA_SOURCE && employmentType === "self_employed" ? "Business Name" : "Organization Name"}
                options={employmentType === "self_employed" ? null : dropDownOptions}
              />
            </div>
            {employmentType !== "self_employed" &&
              <div className="professional-form-input">
                <ShimmerPlaceholder visible={showShimmer} />
                <FloatingInput
                  visible={!showShimmer}
                  value={companyEmail}
                  on_change={updateCompanyEmail}
                  error={companyEmailError}
                  error_message="Please enter a valid email"
                  // type={"text"}
                  type="email"
                  label={customerDetails.source === ESB_DSA_SOURCE && employmentType === "self_employed" ? "Business Email Address" : "Organization Email Address"}
                />
              </div>
            }
            <div className="professional-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={companyAddress}
                on_change={updateCompanyAddress}
                error={companyAddressError}
                error_message="Please enter valid address"
                disabled={companyAddressDisabled}
                type={"text"}
                label={customerDetails.source === ESB_DSA_SOURCE && employmentType === "self_employed" ? "Business Address" : "Organization Address"}
              />
            </div>
            <div className="professional-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={officePincode}
                on_change={updateOfficePincode}
                error={officePincodeError}
                error_message="Please enter a valid pin code"
                disabled={officePincodeDisabled}
                // type={"number"}
                type="Number"
                label={customerDetails.source === ESB_DSA_SOURCE && employmentType === "self_employed" ? "Business Pincode" : "Organization Pincode"}
              />
            </div>
            <div className="professional-form-input professional-form-input-small">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                disabled={true}
                type={"text"}
                value={city}
                label={"City"}
              />
            </div>
            <div className="professional-form-input professional-form-input-small">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                disabled={true}
                value={state}
                type={"text"}
                label={"State"}
              />
            </div>
          </form>
          <div style={{ height: "30px" }}></div>
          <ShimmerPlaceholder
            visible={showShimmer}
            height="6em"
            marginTop="1em"
          />
          <ShimmerPlaceholder
            visible={showShimmer}
            height="2.5em"
            width="9em"
          />
          <div
            style={{ display: showShimmer ? "none" : "flex" }}
            className={"professional-form-img bottomDiv"}
          >

            <Button
              id="ProceedBtn"
              className="Btn ProceedBtn"
              disabled={!allFieldsValidated()}
              mobile={isMobile}
              onClick={
                employmentType === "self_employed"
                  ? gstNumberOptions && gstNumber !== "None Of The Above" ? gstReturnDetails : insertSelfEmployedDetails
                  : callInsertProfessionalDetailsAPI
              }
              text={"Proceed"}
            />
          </div>
        </ProfessionalDetailsWrapper>
      </>
    </>
  );
};

export default ProfessionalDetails;
